import { CSSProperties } from 'react';

import { bodyWidth } from 'constants/values';

export const container: CSSProperties = {
  backgroundColor: '#FBB1A4',
  width: '100%',
};

export const body: CSSProperties = {
  backgroundColor: '#FBB1A4',
  height: 582,
  margin: 'auto',
  position: 'relative',
  width: bodyWidth,
};

export const image1: CSSProperties = {
  height: 324,
  left: 306,
  position: 'absolute',
  top: 114,
  width: 420,
};

export const image2: CSSProperties = {
  height: 554,
  left: 785,
  position: 'absolute',
  top: 0,
  width: 510,
};

export const image3: CSSProperties = {
  height: 84,
  left: 651,
  position: 'absolute',
  top: 460,
  width: 100,
};
